import { Injectable } from "@angular/core";
import { RestService } from "../core/core/rest.service";
import { RcpReportRow } from "./rcpreport.model";

@Injectable()
export class RcpReportRest {
    constructor(private http: RestService) { }

    public getRcpReport(isCurrentMonth: boolean = true){
        return this.http.get<RcpReportRow[]>(`api/extRcpReport/${isCurrentMonth ? 1 : 0}`);
    }
}